import ResizeObserver from 'resize-observer-polyfill';

import NavTabs from './NavTabs';
import NavTabsToggle from './NavTabsToggle';

const mq = window.matchMedia('(min-width: 768px)');
const navTabs = new NavTabs();

const navTabsContainer = document.querySelector('[data-nav-tabs]');

if (navTabsContainer) {
    if (mq.matches) {
        const resizeObserver = new ResizeObserver(() => {
            navTabs.init();
        });

        resizeObserver.observe(navTabsContainer);
    }

    const navTabsToggle = new NavTabsToggle();
    navTabsToggle.init();
}
